import formInputsTypes from '../../simulatorConstant';
import {
	AxeManuelRM,
	bobineRM,
	Butee,
	EnroulementRM,
	MesureHauteur,
	MesureLargeur,
	platBombeRM,
	PoseRM,
} from '../data';

import RideauButee from 'assets/img/rideau-butee.png';
import RideauSansButee from 'assets/img/rideau-sans-butee.png';

export const CATEG_ID_MOTEUR_RIDEAU = 36;


const NbAgrafesRMData = {
	id: 'NbAgrafesRM',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'NbAgrafesRM',
	className: 'col-6',
	label: "Nombre d'agrafes",
	nextStepData: false,
	nextStep: false,
};

const EnroulementData = {
	id: 'RMENROULEMENT',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'Enroulement',
	className: 'col-6',
	label: 'Enroulement',
	nextStepData: NbAgrafesRMData,
	nextStep: false,
	options: EnroulementRM,
};

const MesureHauteurRMData = {
	id: 'RMH',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'MesureHauteur',
	className: 'col-6',
	label: 'Mesure selon hauteur',
	nextStepData: EnroulementData,
	nextStep: false,
	options: MesureHauteur,
};

const hauteurRM = {
	id: 'HRM',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'hauteurRM',
	className: 'col-6',
	label: "Hauteur de l'axe (mm)",
	nextStepData: MesureHauteurRMData,
	nextStep: false,
	validation: (value) => {
		return value > 0;
	},
};

const MesureLargeurRMData = {
	id: 'RM-TML',
	type: formInputsTypes?.RADIO_INPUT,
	name: 'MesureLargeur',
	className: 'col-6',
	label: 'Mesure selon largeur',
	nextStepData: hauteurRM,
	nextStep: false,
	options: MesureLargeur,
};

const largeurRM = {
	id: 'LRM',
	type: formInputsTypes?.INPUT_NUMBER,
	name: 'largeurRM',
	className: 'col-6',
	label: "Largeur de l'axe (mm)",
	nextStepData: MesureLargeurRMData,
	nextStep: false,
	validation: (value) => {
		return value > 0;
	},
};

const PoseRMData = {
	id: 'PoseRM',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Pose',
	name: 'PoseRM',
	className: 'col-6',
	nextStepData: largeurRM,
	nextStep: false,
	options: PoseRM,
};

const bobine = {
	id: 'bobine',
	type: formInputsTypes?.SELECT_INPUT,
	label: 'Bobine',
	name: 'bobine',
	className: 'col-6',
	nextStepData: PoseRMData,
	nextStep: false,
	options: bobineRM,
};

const platBombe = {
	id: 'platBombe',
	type: formInputsTypes?.RADIO_INPUT,
	label: 'Plat bombé',
	name: 'platBombe',
	className: 'col-6',
	nextStepData: bobine,
	nextStep: false,
	options: platBombeRM,
};
const AxeManuelData = {
	id: 'AxeMRMData',
	type: formInputsTypes?.SELECT_INPUT,
	label: "Diamètre d'axe",
	name: 'AxeMRMData',
	className: 'col-6',
	nextStepData: platBombe,
	nextStep: false,
	options: AxeManuelRM,
};

export default AxeManuelData;
